<template>
  <div>
    <base-modal
      id="linkModal"
      size="modal-md"
      :class="{'modal-pdf': display === 'pdf'}"
      :show="showLinkModal"
      :show-close-button="true"
      :modal-alert="true"
      @closed="onClosed"
    >
      <template v-if="display === 'html'">
        <base-heading v-if="message === 0" class="mb-0 heading-title">
          Select Link recipient
        </base-heading>
        <base-heading v-else-if="message === 1" class="mb-0 heading-title">
          Select QR Code recipient
        </base-heading>
        <base-heading v-else class="mb-0 heading-title">
          Select Embed Code recipient
        </base-heading>
        <div style="padding: 0px 24px 0px 24px;">
          <hr
            class="mb-4"
            style="border-color: #d4d4d4; margin-top: unset !important;"
          >
        </div>
        <!-- <hr> -->
      </template>
      <template v-if="display === 'pdf'">
        <base-heading>
          Choose Your PDF Recipient
        </base-heading>
        <div style="padding: 0px 24px 0px 24px;">
          <hr
            class="mb-4"
            style="border-color: #d4d4d4; margin-top: unset !important;"
          >
        </div>
        <!-- <hr> -->
      </template>
      <div class="link__message">
        <template>
          <p class="link-body pt-3 pb-4 px-4 w-100">
            By selecting a recipient, we’ll be able to track opens and clicks for you!
          </p>
        </template>
      </div>
      <client-selector
        :show="selectorsShow.CLIENT"
        shared-link-selector
        separate-bars
        :customers="customers"
        :selected="selectedCustomer"
        :count="customersCount"
        :communication="isEmbedCode() ? 'embed' : 'message'"
        class="select-client"
        @toggle="toggleSelector('CLIENT', $event)"
        @select="selectCustomer"
        @on-search="onSearch"
        @reached-bottom="onBottomReached"
      />
      <template slot="footer" style="margin:unset;">
        <base-button
          nowrap
          class="custombutton--inverse"
          @click="onClosed"
        >
          Cancel
        </base-button>
        <base-button
          :disabled="!selectedCustomer.pk"
          class="custombutton"
          inverse
          @click="onShareClicked"
        >
          <template v-if="display === 'pdf'">
            Download
          </template>
          <template v-else>
            <span v-if="selectedCustomer.pk">
              Create
            </span>
            <span v-else>
              Create
            </span>
          </template>
        </base-button>
      </template>
    </base-modal>
    <base-modal
      v-show="selectedShareMethod"
      id="linkCreatedModal"
      :show="showLinkCreatedModal"
      :show-close-button="true"
      :class="linkCreatedModalClasses"
      @closed="onSuccessModalClosed"
      @shown="onSuccessModalShown"
    >
      <template v-if="display === 'pdf'">
        <base-heading>PDF downloaded</base-heading>
      </template>
      <template v-else>
        <base-heading class="modal-heading-title">
          {{ selectedShareMethod ? selectedShareMethod.successTitle : '' }}
        </base-heading>
      </template>
      <hr
        style="border-color: #d4d4d4; margin-top: unset !important;"
      >
      <!-- <hr> -->
      <div class="d-flex w-100 link__message">
        <div class="pt-2 pb-4 w-100">
          <template v-if="display === 'pdf'">
            <p>
              Your PDF for <strong>{{ selectedCustomer && selectedCustomer.display_name_array ? selectedCustomer.display_name_array[0] : '' }}</strong>
              has been downloaded to your device.
              You can now attach it to a message for your client.
            </p>
          </template>
          <template v-else-if="isEmbedCode() && isEmbedCopied()">
            <template v-if="!embed_enabled">
              <base-skeleton>
                <div class="skeleton__item" />
                <div
                  class="skeleton__item"
                  style="width: 20%"
                />
              </base-skeleton>
            </template>
            <template v-else>
              <base-text style="font-family: 'SilkaLight';">
                {{ selectedShareMethod ? selectedShareMethod.successText : '' }}
              </base-text>
            </template>
          </template>
          <template v-else-if="!isEmbedCode()">
            <base-text class="modal-body-text">
              {{ selectedShareMethod ? selectedShareMethod.successText : '' }}
            </base-text>
          </template>
        </div>
        <div
          v-if="false"
          class="ml-auto"
        >
          <base-button
            v-if="webShareApiSupported"
            @click="shareViaWebShare()"
          >
            Share
          </base-button>
        </div>
      </div>
      <!--
        Please do NOT remove this preview. more info:
        https://helloseer.slack.com/archives/C015UMFDKRS/p1628460045041100
       -->
      <div
        v-if="link && selectedShareMethod && selectedShareMethod.name == 'WeChat' "
        class="ml-auto"
      >
        <img
          :src="link"
          style="width:100%;"
        >
      </div>
      <div
        v-if="selectedShareMethod && selectedShareMethod.id === EMBED"
      >
        <base-skeleton v-show="!embed_enabled">
          <div
            class="skeleton__item"
            style="height: 380px"
          />
        </base-skeleton>

        <embed-code
          v-show="embed_enabled"
          ref="code"
          v-bind="{ link, title, hero}"
          @ready="embed_enabled = true"
          @open="embed_enabled = false"
        />
      </div>

      <div
        v-if="isEmbedCode()"
        class="embed-copy-div"
      >
        <base-button
          style="margin: unset !important; height: 36px; padding: 11px 20px"
          width="38"
          height="184"
          inverse
          :disabled="!embed_enabled"
          @click="copyEmbedCode()"
        >
          Copy
        </base-button>
      </div>

      <div
        v-show="selectedShareMethod && (selectedShareMethod.id === TEXT || display == 'pdf')"
        class="shared-link"
      >
        <a
          v-show="false"
          ref="pdfLink"
          :href="link"
          :target="(browserClass === 'is-safari')? '_blank':''"
          :download="`${selectedCustomer.first_name}_${selectedCustomer.last_name}.pdf`"
        >Download PDF</a>
        <template v-if="display !== 'pdf'">
          <input
            id="sharedLinkInput"
            ref="copyLinkInput"
            v-model="link"
            readonly
            type="text"
            class="form-control shared-link__input"
            @keyup.enter="onKeyUp"
          >

          <span class="clickable shared-link__icon">
            <!-- No tooltip -->
            <!-- <base-icon
            v-if="!copyTooltip"
            icon="appointment-link"
            class="clickable shared-link__icon"
            @click="onCopyLinkClicked"
          /> -->

            <!-- Tooltip -->
            <base-tooltip
              ref="createdLink"
              :text="tooltipText[tooltipTextStatus]"
              @closed="tooltipTextStatus = 0"
            >
              <base-icon
                style="width: 18px; height: 18px;"
                icon="appointment-link"
                @click="onCopyLinkClicked"
              />
            </base-tooltip>
          </span>
        </template>
      </div>
    </base-modal>
    <base-modal
      v-show="showEmbedCodeConfirmModal"
      id="embedCodeModal"
      :modal-alert="true"
      :show="showEmbedCodeConfirmModal"
      @closed="onSuccessModalClosed"
    >
      <base-heading>Done!</base-heading>
      <hr
        class="mb-4"
        style="border-color: #d4d4d4; margin-top: unset !important;"
      >
      <!-- <hr> -->
      <div class="d-flex w-100">
        <div class="pt-2 pb-4">
          <base-text style="padding-left: 20px; padding-top: 10px;">
            Your embed code has been copied to your clipboard.
          </base-text>
        </div>
      </div>
    </base-modal>
  </div>
</template>

<script>

import _ from 'lodash';
import Listable from '@/components/mixins/listable';
import whichbrowser from '@/components/mixins/whichbrowser';
import { outreachService, entryService } from '@/_services';
import { EventBus } from '@/event-bus';
import {
  TEXT, WECHAT, EMBED, METHODS,
} from '@/components/Widgets/DraftEditor/LinkShareMethodSelector';
import ClientSelector from '../ClientSelector';
import EmbedCode from './EmbedCode';

export default {
  name: 'LinkCreationModal',
  components: {
    ClientSelector,
    EmbedCode,
  },
  mixins: [Listable, whichbrowser],
  props: {
    source: {
      type: String,
      default: 'customers',
    },
    show: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Number,
      required: true,
    },
    mode: {
      type: String,
      default: 'loadMore',
    },
    pageSize: {
      type: Number,
      default: 15,
    },
    display: {
      type: String,
      default: 'html',
      validator(value) {
        return ['html', 'pdf', 'wechat', 'embed'].indexOf(value) !== -1;
      },
    },
    preventDefaultClose: {
      type: Boolean,
      default: false,
    },
    message: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      tooltipText: ['Copy Link', 'Copied to clipboard!'],
      tooltipTextStatus: 0,

      showLinkModal: false,
      showLinkCreatedModal: false,

      selectedCustomer: {
        first_name: '',
        last_name: '',
        pk: -1,
        display_name_array: ['', ''],
      },
      loading: false,
      selectedShareMethod: null,
      link: '',
      embed_enabled: false,
      TEXT,
      WECHAT,
      EMBED,
      hero: null,
      logo: null,
      title: '',
      selectorsShow: {
        CLIENT: false,
        SHARE_METHOD: false,
      },
      copyTooltip: false,
      file_content: null,
      embedCodeCopied: false,
      showEmbedCodeConfirmModal: false,
      testUser: {
        pk: -1,
        first_name: 'Test',
        last_name: 'User',
        is_mine: true,
      },
    };
  },
  computed: {
    webShareApiSupported() {
      return navigator.share;
    },
    customers() {
      return [this.testUser, ...this.$store.state.customers.items];
    },
    customersCount() {
      return this.$store.state.customers.count;
    },
    profilePk() {
      return this.$store.state.account.user.profile.pk;
    },
    linkCreatedModalClasses() {
      return {
        'modal--embed': this.selectedShareMethod && this.selectedShareMethod.id === this.EMBED,
        'modal--wechat': this.selectedShareMethod && this.selectedShareMethod.id === this.WECHAT,
      };
    },
  },
  watch: {
    show(value) {
      if (value) {
        // Reset selection
        this.selectedShareMethod = (this.display === 'pdf') ? METHODS[TEXT] : null;
        this.selectedCustomer = {
          first_name: '',
          last_name: '',
        };
        this.startClientFetch();
      }
      this.showLinkModal = value;
    },
    link(value) {
      if (value) {
        if (this.display === 'pdf') this.download(this.link, 'edit.pdf');
        if (this.display === 'wechat') this.downloadWeChatImage();
      }
    },
    // showLinkCreatedModal(newval) {
    //   if (newval)
    //     this.copyLink()
    // }
  },
  mounted() {
    this.queryParams = {
      via_client_autocomplete: 1,
      ...this.queryParams,
    };
  },
  methods: {
    showSuccessModal() {
      this.showLinkCreatedModal = true;
    },
    download(fileURL, fileName) {
      const newWindow = window.open(fileURL, '_blank');
      newWindow.document.close();
      newWindow.document.execCommand('SaveAs', true, fileName || fileURL);
      newWindow.close();
    },
    loadXHR(url) {
      return new Promise((resolve, reject) => {
        try {
          const xhr = new XMLHttpRequest();
          xhr.open('GET', url);
          xhr.responseType = 'blob';
          xhr.onerror = () => {
            reject(new Error('Network error.'));
          };
          xhr.onload = () => {
            if (xhr.status === 200) {
              console.log(xhr.response);
              this.file_content = xhr.response;
              resolve(xhr.response);
            } else {
              reject(new Error(`Loading error:${xhr.statusText}`));
            }
          };
          xhr.send();
        } catch (err) {
          console.log(err.message);
          reject(err.message);
        }
      });
    },
    shareViaWebShare() {
      navigator.share({
        title: 'Title to be shared',
        text: 'Text to be shared',
        url: this.link,
      }).catch((err) => {
        console.log(err);
        console.log(err.message);
      });
    },
    startClientFetch() {
      this.$store.dispatch('customers/customReset');
      if (this.truePage === 1) {
        this.fetchData();
      } else {
        this.truePage = 1;
      }
    },
    toggleSelector(currentSelectorKey, show) {
      this.selectorsShow[currentSelectorKey] = show;
      // close others
      if (show) {
        Object.keys(this.selectorsShow).forEach((key) => {
          if (key !== currentSelectorKey) this.selectorsShow[key] = false;
        });
      }
    },
    // eslint-disable-next-line
    onSearch: _.debounce(function (evt) {
      this.search = evt;
    }, 200),
    testLinkCreated(link, hero, title) {
      this.link = link;
      this.hero = hero;
      this.title = title;
      this.showSuccessModal();
    },
    downloadWeChatImage() {
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = this.link;
      a.click();
      document.body.removeChild(a);
    },
    createTestForWeChat() {
      entryService.getWeChatForEdit(this.edit).then((response) => {
        this.display = 'wechat';
        this.link = response.data.href;
        this.showSuccessModal();
        this.downloadWeChatImage();
      });
    },
    isEmbedCopied() {
      return this.browserClass !== 'is-safari' || this.embedCodeCopied;
    },
    createEmbed() {
      this.createLink()
        .then(() => {
          this.copyFormatted(this.$refs.code.html());
        });
    },
    copyEmbedCode() {
      this.embedCodeCopied = true;
      this.copyFormatted(this.$refs.code.html());
      this.showLinkCreatedModal = false;
      this.showEmbedCodeConfirmModal = true;
    },
    isEmbedCode() {
      /**
       * For some reason, selectedShareMethod is populated after the user select the recipient
       * later selectedShareMethod = METHODS[this.message].id
       * Need the value before it is selected, thus using the METHODS[this.message].id
       */
      if (this.selectedShareMethod == null && METHODS[this.message]) {
        return METHODS[this.message].id === EMBED;
      } else {
        return this.selectedShareMethod && this.selectedShareMethod.id === EMBED;
      }
    },
    createLink() {
      const data = {
        display: this.display,
        customer: this.selectedCustomer.pk,
        outreach: {
          edit: this.edit,
          sender: this.profilePk,
        },
      };

      if (this.selectedShareMethod.id === EMBED) {
        data.embedded = true;
      }

      return outreachService.createLinkOutreach(data).then((response) => {
        this.link = response.data.href;
        this.hero = response.data.hero;
        this.logo = response.data.logo;
        this.title = response.data.title;
        this.showSuccessModal();
        if (this.display === 'pdf') {
          this.$nextTick().then(() => {
            console.log('REFS', this.$refs);
            setTimeout(
              () => {
                console.log('REFS', this.$refs);
                this.$refs.pdfLink.click();
              }, 250,
            );
            // this.$refs.pdfLink.click();
          });
          // window.open(this.link, '_blank');
        }
        // this.copyLink()
      }).catch((e) => {
        console.log('E', e);
        EventBus.$emit('toast-error', 'There\'s on link creation, please try again in a few seconds.');
      }).finally(() => {
        // this.onClosed();
        this.loading = false;
      });
    },
    downloadForWechat() {
      this.display = 'wechat';
      this.createLink();
    },
    selectCustomer(customer) {
      this.selectedCustomer = customer;
    },
    onBottomReached() {
      if (this.nextPageExists) {
        this.truePage += 1;
      }
    },
    onSearchShareMethod(search) {
      console.log('Searchshare method', search);
    },
    onShareClicked() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.selectedShareMethod = METHODS[this.message];
      if (this.selectedShareMethod === null) {
        return;
      }
      if (this.selectedCustomer.pk === -1) {
        if (this.display === 'pdf') {
          console.log('pdf');
          this.$emit('old-pdf-method', true);
        } else if (this.selectedShareMethod.id === EMBED) {
          this.$emit('old-link-method', true);
        } else if (this.selectedShareMethod.id === TEXT) {
          this.$emit('old-link-method', true);
        } else {
          this.createTestForWeChat();
        }
        return;
      }
      console.log('this.selectedShareMethod.id ', this.selectedShareMethod.id);
      if (this.selectedShareMethod.id === TEXT) {
        this.createLink();
      } else if (this.selectedShareMethod.id === WECHAT) {
        this.downloadForWechat();
      } else if (this.selectedShareMethod.id === EMBED) {
        this.createEmbed();
      }
    },
    resetData() {
      this.showLinkModal = false;
      this.showLinkCreatedModal = false;
      this.loading = false;
      this.selectedCustomer = {
        first_name: '',
        last_name: '',
      };
      this.selectorsShow = {
        CLIENT: false,
        SHARE_METHOD: false,
      };
      this.copyTooltip = false;
      this.file_content = null;
    },
    onClosed() {
      this.resetData();
      this.$emit('close-link-modal');
    },
    onSuccessModalClosed() {
      if (this.preventDefaultClose) {
        this.showLinkCreatedModal = false;
        return;
      }
      /*
      We need to wait the nexttick before push to another page
      or the modal-view will be a zombi component
      */
      this.$nextTick(() => {
        // Redirect to edit sent view if user is not test
        if (this.selectedCustomer.pk !== -1) {
          const { pk } = this.$store.state.entries.item;
          this.$router.push(`/entries/${pk}/sent`);
        } else {
          this.onClosed();
          this.link = '';
          this.selectedShareMethod = null;
        }
      });
    },
    onKeyUp() {
      // lint purposes
    },
    copyLink() {
      if (this.isIPad) {
        this.iosCopyToClipboard(document.getElementById('sharedLinkInput'));
        return;
      }

      if (document.getElementById('sharedLinkInput')) {
        document.getElementById('sharedLinkInput').select();
      }

      try {
        window.Clipboard.copy(this.link);
        document.execCommand('copy');
        // resolve();
      } catch (e) {
        // reject();
        EventBus.$emit('toast-error', 'Couldn\'t copy link to clipboard, please wait a few seconds and try again.');
      }
    },
    onCopyLinkClicked() {
      this.copyLink();
      this.copyTooltip = true;
      this.tooltipTextStatus = 1;
      setTimeout(() => {
        this.$refs.createdLink.close();
      }, 2000);
    },
    iosCopyToClipboard(el) {
      console.log('IOS copy');
      el.focus();
      el.select();
      const oldContentEditable = el.contentEditable;
      const oldReadOnly = el.readOnly;
      const range = document.createRange();

      el.contentEditable = true;
      el.readOnly = false;
      range.selectNodeContents(el);

      const s = window.getSelection();
      s.removeAllRanges();
      s.addRange(range);

      el.setSelectionRange(0, 999999); // A big number, to cover anything that could be inside the element.

      el.contentEditable = oldContentEditable;
      el.readOnly = oldReadOnly;

      document.execCommand('copy');
      el.blur();
    },
    onSuccessModalShown() {
      if (this.selectedShareMethod && this.selectedShareMethod.id === TEXT) {
        this.copyLink();
      }

      // if (this.selectedShareMethod && this.selectedShareMethod.id === EMBED) {
      //   this.$nextTick().then(() => {
      //     this.copyEmbedCode();
      //   });
      // }
    },
    copyFormatted(html) {
      // Create an iframe (isolated container) for the HTML
      const container = document.createElement('div');
      container.innerHTML = html;

      const clickLink = container.querySelector('.click_link');
      if (clickLink) {
        clickLink.style.fontFamily = 'Arial';
        clickLink.style.fontSize = '16px';
        clickLink.style.fontWeight = 'normal';
        clickLink.style.top = '0px';
        clickLink.style.backgroundColor = 'transparent';
      }

      const br = container.querySelector('br');
      if (br) {
        br.remove();
      }

      // Hide element
      container.style.position = 'fixed';
      container.style.pointerEvents = 'none';
      container.style.opacity = '1';

      // Detect all style sheets of the page
      // eslint-disable-next-line
      const activeSheets = Array.prototype.slice.call(document.styleSheets)
        .filter((sheet) => !sheet.disabled);

      // Mount the iframe to the DOM to make `contentWindow` available
      document.body.appendChild(container);

      // Copy to clipboard
      window.getSelection().removeAllRanges();

      const range = document.createRange();
      range.selectNode(container);
      window.getSelection().addRange(range);
      document.execCommand('copy');
      // window.Clipboard.copy(this.$refs.code.html());

      // Remove the iframe
      document.body.removeChild(container);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .modal-dialog {
  max-width: 500px !important;
  max-height: inherit !important;
  .modal-content {
    .close {
      // transform: scale(1.5);
      margin-right: 18px;
      margin-top: -5px;
    }
  }
}
/*
Custom size for Embed modal
This is not the best apporach.
We need to normalize design system with
Frontend components
*/
.modal--embed::v-deep .modal-dialog {
  max-width: 468px !important;
  max-height: inherit !important;
}
.modal--wechat::v-deep .modal-content {
  padding-bottom: 5px !important;
  min-height: 568px !important;
}
::v-deep .modal-content {
  padding: 15px;
}
::v-deep .form-control {
  &[readonly] {
    background-color: transparent !important;
  }
  &::selection {
    background-color: $bone;
  }
}
.embed-copy-div {
  padding-top: 0;
  padding-bottom: 0;
  display: flex;
  justify-content: flex-end;
}

.shared-link {
  display: flex;
  align-items: center;
  margin-right: 0.3rem;

  &__input {
    font-family: $font-family-sans-serif-light;
    padding: 0.55rem 2.7rem 0.55rem 0.8125rem ;
    border-radius: 5px;
    min-width: 100%;
  }
  &__icon{
    margin-left: -2rem;
  }
}
.link__message{
  font-family: 'SilkaLight';
  font-size: 16px;
  line-height: 1rem;
  text-rendering: geometricPrecision;
  color: $gray;
  // padding: 24px;

  strong{
    font-family: $font-family-sans-serif-semibold;
  }
}

/**
* This button is different - It was designed like this.
* Is not following the design system
* @See https://www.figma.com/file/gUYi3D9a7b4FAMElnnbOKv/Web-Dashboard---Master?node-id=145%3A1071
*/
/**
This header does not follow the design system
is custom for this screen
*/
.pdf-heading{
  @extend %silka-bold;
  font-size: 18px;
  line-height: 22px;
  color: #333333;
  margin-bottom: 8px;
}

.pdf-body{
  @extend %silka;
  font-size: 14px;
  line-height: 20px;
  color: $gray;
}

.link-body{
  @extend %silka;
  font-size: 14px;
  line-height: 20px;
  color: $gray;
  margin-bottom: unset;
}

/**
...And again, this is not the design system standard.
but we are doing everything possible to match Figma
*/
// .modal-pdf::v-deep .modal-body{
//   padding-left: 30px;
//   padding-right: 30px;
// }
.modal-pdf::v-deep .modal-content{
  max-width: 500px;
  border-radius: 0;
}
.modal-body-text {
  font-family: 'SilkaLight';
  font-size: 16px;
  color: #1B1B1B;
}
.modal-heading-title {
  font-family: 'Tiempos Headline';
  font-weight: 600;
  font-size: 19px;
  line-height: 120%;
  letter-spacing: 0.01em;
  color: #1B1B1B;
  margin-bottom: 1.5rem !important;
}
::v-deep .modal-dialog .modal-content{
  padding: 8px;
  padding-top: 10.5px;
  .close {
    top: 27px;
  }
}
.heading-title {
  font-family: 'Tiempos Headline';
  font-weight: 600;
  font-size: 19px;
  padding-bottom: 5px;
}
.custombutton {
  border:unset !important;
  border-radius: 5px !important;
  font-size: 14px !important;
  padding: 12px 20px;
  border-radius: 5px !important;
  margin: unset !important;
  margin-right: 3px !important;
  height: 36px !important;
  font-family: 'SilkaLight';

  &--inverse {
    font-size: 14px !important;
    border-radius: 4px;
    border: 1px solid #C6C6C6;
    font-size: 12px;
    padding: 6px 16px;

  }
}
::v-deep .select-client{
  .base-select__label{
    text-transform: none;
    font-family: 'SilkaLight';
    font-size: 14px;
  }
}
</style>
